module.exports = __webpack_public_path__ + "static/about-team4-3be24a8f200c8ba26f23dcb3def810ff.jpg";